import Component from "../component.abstract";
import { getSingleInstanceByElement } from "../../core";
import ValidatedForm from "../form/validated-form/validated-form";

export default class ProgressButton extends Component {
    private rawParameters: string;
    private parameters: any;
    private form: HTMLFormElement;
    private fakeButton: HTMLElement;
    private dataCyId: string
    private isSubmitted = false

    constructor(private props: unknown, element: HTMLElement) {
        super(props, element);
    }

    mounted(): void {
        // The related form is passed through this attribute
        this.rawParameters = this.element.getAttribute("data-progress-button");
        if (this.rawParameters) {
            try {
                this.parameters = JSON.parse(this.rawParameters);
            } catch(e) { e }
            
            if (this.parameters.form) {
                this.form = <HTMLFormElement> document.getElementById(this.parameters.form);
            }

            //FIXME : stock or not ?
            if (this.parameters.dataCyId) {
                this.dataCyId = this.parameters.dataCyId
            }
        }

        const buttonText: string = (<HTMLInputElement> this.element).value;
        this.fakeButton = document.createElement("span");
        if (this.dataCyId) {
            this.fakeButton.setAttribute("data-cy", this.dataCyId)
        }
        const classes = this.element.classList.value.split(" ");
        classes.forEach((elementClass: string) => {
            this.fakeButton.classList.add(elementClass);
        });
        
        const content: HTMLElement = document.createElement("span");
        content.classList.add("progress-content");
        content.innerHTML = buttonText;
        const progress: HTMLElement = document.createElement("span");
        progress.classList.add("progress");

        const element: HTMLElement = this.rawParameters ? this.fakeButton : this.element;
        element.innerHTML = '';
        element.appendChild(content);
        element.appendChild(progress);

        if (this.rawParameters) {
            if (getSingleInstanceByElement("ValidatedForm", this.element)) {
                this.element.parentNode.insertBefore(this.fakeButton, this.element);
                this.element.remove();
                this.fakeButton.addEventListener("click", () => {
                    this.progress();
                });
            }
        } else {
            this.element.addEventListener("click", () => {
                this.progress();
            });
        }
    }

    progress() {
        let progress = true,
            form: ValidatedForm;

        if (document.querySelectorAll('[data-smartapply]').length === 1) {
            Array.from(document.querySelectorAll('[data-job-submit]')).forEach((button : HTMLElement) => {
                form = getSingleInstanceByElement("ValidatedForm", button);
                if (form) {
                    progress = form.check();
                }
            });

            if (progress) {
                this.element?.classList.remove("progress-inner");
                setTimeout(function() {
                    this.element?.classList.add("progress-inner");
                }, 100);
            }
        } else {
            form = getSingleInstanceByElement("ValidatedForm", this.element);
            if (form) {
                progress = form.check();
            }
            
            if (progress) {
                if (!this.rawParameters) {
                    if(document.querySelectorAll('.lp_form').length == 0 && 
                        document.querySelectorAll('[data-crea-alertlibre]').length === 0  ) {
                        // Specific case for LP on-boarding, to redirect + Geoloc ParisJob
                        this.element.setAttribute('disabled', 'disabled');
                    }
                    this.element.classList.remove("progress-inner");
                    if (document.querySelectorAll('[data-crea-alert]').length === 0){
                        setTimeout(() => {
                            this.element?.classList.add("progress-inner");
                        }, 100);
                    }
                } else {
                    this.element.classList.remove("progress-inner");
                    this.fakeButton.parentNode.insertBefore(this.element, this.fakeButton);
                    this.fakeButton.remove();
                    setTimeout(() => {
                        this.element?.classList.add("progress-inner");
                        setTimeout(() => {
                            if (this.form) {
                                this.element.setAttribute("disabled", "disabled");
                                this.submitForm()
                            } else {
                                if (!this.isSubmitted) {
                                    // [SE-7815] adding a boolean flag to prevent multiple boolean
                                    this.element.click()
                                    this.isSubmitted = true
                                }
                            }
                        }, 100);
                    }, 100);
                    
                }
            } else {
                if (!this.rawParameters) {
                    this.element.removeAttribute('disabled');
                }           
            }
        }
    }

    /**
     * Adding flag to prevent multi submit
     * [SE-7815] Multiple submit
     * We suspect too many timeout on short times (100ms) when submitting the form
     * @private
     */
    private submitForm (): void {
        if (!this.isSubmitted) {
            // fakeButton replaces current submit function (initialized in form.ts) so we need to get the instance of it
            // On sponform because it needs to notify after
            const dataForm = getSingleInstanceByElement("Form", this.form)

            this.form.id === "sponform" ? dataForm.submit() : this.form.submit()

            // Adding boolean flag to prevent further submit
            this.isSubmitted = true
        }
    }
}